import { BuiltBaselineDetails } from './built-baseline-details';

/** The persisted derivation plus the event currency to show it in (the currency is not persisted with it). */
export interface BuiltBaselineDetailsModalState {
  currency: string;
  details: BuiltBaselineDetails;
}

let globalSetter: ((state: BuiltBaselineDetailsModalState | null) => void) | null = null;

/** Global trigger/container pattern, same shape as build-baseline-store's registerBuildBaselineSetter. */
export const registerBuiltBaselineDetailsSetter = (
  setter: ((state: BuiltBaselineDetailsModalState | null) => void) | null,
): void => {
  globalSetter = setter;
};

/** Opens the singleton modal (mounted once in Lots.tsx) with this row's persisted derivation. */
export const showBuiltBaselineDetailsModal = (details: BuiltBaselineDetails, currency: string): void => {
  globalSetter?.({ currency, details });
};

export const closeBuiltBaselineDetailsModal = (): void => {
  globalSetter?.(null);
};
